import { Link } from 'react-router-dom';

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white pt-16 sm:pt-20 pb-8">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-12 sm:mb-16">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/638c1803-b247-452b-978a-cc144ee7337b.png" 
              alt="赤石会計事務所" 
              className="h-10 sm:h-12 w-auto object-contain mb-4 sm:mb-6"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-4 sm:mb-6">
              勝つ経営を実現する、経営者のための会計事務所
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-red transition-colors rounded-full flex items-center justify-center cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-red transition-colors rounded-full flex items-center justify-center cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-red transition-colors rounded-full flex items-center justify-center cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4 sm:mb-6 text-red">サービス</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link
                  to="/services"
                  onClick={handleLinkClick}
                  className="text-gray-400 hover:text-red transition-colors text-sm cursor-pointer"
                >
                  勝つ経営コース
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  onClick={handleLinkClick}
                  className="text-gray-400 hover:text-red transition-colors text-sm cursor-pointer"
                >
                  お勧めコース
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  onClick={handleLinkClick}
                  className="text-gray-400 hover:text-red transition-colors text-sm cursor-pointer"
                >
                  お手軽コース
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  onClick={handleLinkClick}
                  className="text-gray-400 hover:text-red transition-colors text-sm cursor-pointer"
                >
                  追加サービス
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  onClick={handleLinkClick}
                  className="text-gray-400 hover:text-red transition-colors text-sm cursor-pointer"
                >
                  料金について
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4 sm:mb-6 text-red">会社情報</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link
                  to="/"
                  onClick={handleLinkClick}
                  className="text-gray-400 hover:text-red transition-colors text-sm"
                >
                  トップページ
                </Link>
              </li>
              <li>
                <Link
                  to="/mission"
                  onClick={handleLinkClick}
                  className="text-gray-400 hover:text-red transition-colors text-sm"
                >
                  経営理念
                </Link>
              </li>
              <li>
                <Link
                  to="/tax-accountant-guide"
                  onClick={handleLinkClick}
                  className="text-gray-400 hover:text-red transition-colors text-sm"
                >
                  税理士の見分け方
                </Link>
              </li>
              <li>
                <Link
                  to="/profile"
                  onClick={handleLinkClick}
                  className="text-gray-400 hover:text-red transition-colors text-sm"
                >
                  プロフィール
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-bold mb-4 sm:mb-6 text-red">お問い合わせ</h3>
            <ul className="space-y-3 sm:space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-red text-lg flex-shrink-0 mt-0.5"></i>
                <div>
                  <div className="text-sm text-gray-400 mb-1">電話</div>
                  <a
                    href="tel:075-351-0587"
                    className="text-white hover:text-red transition-colors cursor-pointer text-sm sm:text-base"
                  >
                    075-351-0587
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-red text-lg flex-shrink-0 mt-0.5"></i>
                <div>
                  <div className="text-sm text-gray-400 mb-1">所在地</div>
                  <div className="text-white text-sm leading-relaxed">
                    〒600-8417<br />
                    京都府京都市下京区<br />
                    松原不明門東入俊成446-3F
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 sm:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-xs sm:text-sm text-center md:text-left">
              © 2024 赤石会計事務所. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red transition-colors text-xs sm:text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
